<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-12">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Документы, подтверждающие полномочия представителя Пользователя ЭПЭ') }}
            </v-toolbar-title>
          </v-toolbar>
          <general-error v-if="!!generalError" />
          <v-card-text>
            <user-authorization-documents-list
                ref="authorizationDocumentList"
                :authorization-documents="authorizationDocuments"
                :total-count="totalCount"
                :edited="getCurrentUserAuthorizationDocumentList"
                :loading="isLoading"
                can-create
                :create-method="createUserAuthorizationDocument"
                :document-type="documentType"
                :document-group="documentGroup"
                enable-filters />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import UserAuthorizationDocumentsList from '@/components/reused/authorizationDocuments/UserAuthorizationDocumentsList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { AUTHORIZATION_DOCUMENT_TYPES, IDENTITY_DOCUMENT_GROUPS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { CURRENT_AUTHORIZATION_DOCUMENTS } from '@/constants/store.js'

  export default {
    components: {
      UserAuthorizationDocumentsList,
      GeneralError
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(CURRENT_AUTHORIZATION_DOCUMENTS.NAMESPACE, {
        authorizationDocumentsInfo: state => (state[CURRENT_AUTHORIZATION_DOCUMENTS.STATE.AUTHORIZATION_DOCUMENTS] || {})
      }),
      headers () {
        return [
          { text: this.$t('Документ'), sortable: false, value: 'file.fileName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('ФИО доверенного лица'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: this.$t('Действия'), sortable: false, value: 'file.fileId' }
        ]
      },
      authorizationDocuments () {
        return this.authorizationDocumentsInfo.items || []
      },
      totalCount () {
        return this.authorizationDocumentsInfo.totalCount || 0
      },
      documentType () {
        return AUTHORIZATION_DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT
      },
      documentGroup () {
        return IDENTITY_DOCUMENT_GROUPS.ORGANIZATION_AGENT_DOCUMENTS
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(CURRENT_AUTHORIZATION_DOCUMENTS.NAMESPACE, {
        getCurrentUserAuthorizationDocumentListAction: CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST,
        createUserAuthorizationDocumentAction: CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.CREATE_USER_AUTHORIZATION_DOCUMENT,
        clearCurrentUserAuthorizationDocumentListAction: CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearCurrentUserAuthorizationDocumentListAction()
          ])
      },
      getCurrentUserAuthorizationDocumentList: async function (params) {
        try {
          this.isLoading = true
          await this.getCurrentUserAuthorizationDocumentListAction(params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      createUserAuthorizationDocument: async function (authorizationDocument) {
        try {
          this.isLoading = true

          await this.createUserAuthorizationDocumentAction({
            authorizationDocument
          })
          this.isLoading = false
          this.$refs.authorizationDocumentList.getAuthorizationDocumentsList()
        } catch (error) {
          this.isLoading = false
          throw error
        }
      }
    }
  }
</script>
